import {getCoreAxiosInstance} from '@utils/axios';

// Must be called synchronously inside a click handler. We open the new tab
// first so it inherits the click's user-activation token; if we waited until
// the SSO response, Safari/Chrome would block the popup. Once the SSO URL
// arrives we redirect the already-open tab. If the popup was blocked outright
// (`win` is null), we fall back to top-level navigation so the user still
// reaches the marketplace.
export function openMarketplaceSSO() {
  const win = window.open('', '_blank');
  if (win) { try { win.opener = null; } catch (_) { /* noop */ } }

  return getCoreAxiosInstance().post('/sso/issue').then(res => {
    if (win && !win.closed) {
      win.location.href = res.data.url;
    } else {
      window.location.assign(res.data.url);
    }
  }).catch(err => {
    if (win && !win.closed) win.close();
    throw err;
  });
}
